// extracted by mini-css-extract-plugin
export default {"tooltip-inner":"TooltipCentral_tooltip-inner__LmQx4","tooltip":"TooltipCentral_tooltip__w-1N1","tootltip-arrow":"TooltipCentral_tootltip-arrow__PvwxL"};